import CompanySection from "@/src/views/onboarding/CompanySection.vue";
import ConnectSection from "@/src/views/onboarding/ConnectSection.vue";
import TeamsSection from "@/src/views/onboarding/TeamsSection.vue";


export const onboardingSteps = {
  INCOMPLETE: "INCOMPLETE",
  WORKSPACE: "WORKSPACE",
  ADD_COMPANY: "ADD_COMPANY",
  CONNECT_EMAIL: "CONNECT_EMAIL",
  TEAM_INVITES: "TEAM_INVITES",
  ONBOARDING_COMPLETE: "ONBOARDING_COMPLETE",
};
